import { useEffect } from 'react';
import { apolloAdapter } from '@warehouse/shared/infra';
import { brokerFetchClientAdapter, inventoryFetchClientAdapter } from '@warehouse/object-browser/infra';
import { TokenGetterOutput } from '../hooks';
import { authScopesRepositorySingleton } from '../infra';

export function TokenGetterSetter({ tokenGetter }: { tokenGetter: TokenGetterOutput['tokenGetter'] }) {
	useEffect(() => {
		apolloAdapter.setTokenGetter(tokenGetter);
		inventoryFetchClientAdapter.setTokenGetter(tokenGetter);
		brokerFetchClientAdapter.setTokenGetter(tokenGetter);
		authScopesRepositorySingleton.get().setTokenGetter(tokenGetter);
	}, [tokenGetter]);
	return null;
}
